<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a><a id="page_vi">
<p class="title1_a">The House of Mapuhi</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_part1.vue?443fbf35